'use strict';

const checkResult = res => {
  if (res.success !== true) {
    throw new Error(res.message || 'transaction not successful');
  }
};

export { checkResult };
